import { ReactElement, useCallback, useEffect, useState } from 'react';

import { faMagnifyingGlass } from '@awesome.me/kit-379289146f/icons/classic/light';
import { AccessTextField } from '@changegps/horizon-component-library';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, TextFieldProps } from '@mui/material';

interface SearchBarProps {
  onChangeSearchString: (str: string) => void;
  placeholder: string;
}

export const SearchBar = ({
  onChangeSearchString,
  placeholder,
}: SearchBarProps): ReactElement => {
  const [searchString, setSearchString] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      onChangeSearchString(searchString);
    }, 800);

    return () => {
      clearTimeout(timer);
    };
  }, [searchString, onChangeSearchString]);

  const handleSetSearchStringFilter = useCallback<
    NonNullable<TextFieldProps['onChange']>
  >((event) => {
    setSearchString(event.target.value);
  }, []);

  return (
    <Box>
      <AccessTextField
        fullWidth
        placeholder={placeholder}
        value={searchString}
        onChange={handleSetSearchStringFilter}
        InputProps={{
          startAdornment: (
            <FontAwesomeIcon
              icon={faMagnifyingGlass as IconProp}
              color="#73808B"
              style={{
                paddingRight: 6,
              }}
            />
          ),
        }}
      />
    </Box>
  );
};
